import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Realtime } from 'ably';

import { CFD_EVENTS } from '~/main/namespace';
import { LoggerScope } from '~/main/utils/logger';
import { connectionActions } from '~/renderer/store/connection';
import { CONNECTION_STATUS } from '~/renderer/store/connection/types';
import { receiptActions } from '~/renderer/store/receipt';
import Logger from '~/renderer/utils/logger';

const useNetworkChange = (client: Realtime | null) => {
  const dispatch = useDispatch();
  const setDisconnected = React.useCallback(() => {
    dispatch(
      connectionActions.updateAblyConnectionStatus({ status: CONNECTION_STATUS.DISCONNECTED }),
    );
    dispatch(receiptActions.updateIsSaleVisible(false));
  }, [dispatch]);

  React.useEffect(() => {
    const updateOnlineStatus = () => {
      Logger({ scope: LoggerScope.HUB }).debug({
        msg: 'Network status changed!',
        isOnline: navigator.onLine,
      });
      if (navigator.onLine) {
        client?.connection.connect();
      } else if (!navigator.onLine) {
        client?.close();
        setDisconnected();
        window.ipcRenderer?.send(CFD_EVENTS.NOTIFY_CFD_DISCONNECT);
      }
    };

    const bindOnlineStatusOnLoad = () => {
      window.addEventListener('online', updateOnlineStatus);
      window.addEventListener('offline', updateOnlineStatus);
    };

    window.addEventListener('load', bindOnlineStatusOnLoad);

    return () => {
      window.removeEventListener('online', updateOnlineStatus);
      window.removeEventListener('offline', updateOnlineStatus);
      window.removeEventListener('load', bindOnlineStatusOnLoad);
    };
  }, [client, setDisconnected]);
};

export { useNetworkChange };
